/** Расстояние от правого края ячейки (px), в котором захватывается граница для ресайза колонки */
const RESIZE_GUTTER = 6

/**
 * Включает перетаскивание границ колонок таблицы в SunEditor.
 * @param {object} sunEditor — экземпляр SunEditor (из getSunEditorInstance)
 * @param {function(string): void} onResizeEnd — вызывается после окончания ресайза с актуальным HTML
 */
export function attachTableColumnResize(sunEditor, onResizeEnd) {
  if (!sunEditor?.core) return
  const editorEl = sunEditor.core.context?.element?.wysiwygFrame
    || sunEditor.core.context?.element?.wysiwyg
  if (!editorEl) return
  const doc = editorEl.contentDocument || editorEl.contentWindow?.document || (editorEl.ownerDocument || document)
  const container = doc.body || editorEl

  let state = { active: false, table: null, colIndex: 0, startX: 0, startWidth: 0, startTableWidth: 0, isLastCol: false }

  const onMouseMove = (e) => {
    if (!state.active || !state.table) return
    const delta = e.clientX - state.startX
    const newWidth = Math.max(20, state.startWidth + delta)
    const rows = state.table.querySelectorAll('tr')
    rows.forEach(row => {
      const cell = row.cells[state.colIndex]
      if (cell) cell.style.width = newWidth + 'px'
    })
    if (state.isLastCol) {
      const newTableWidth = Math.max(20, state.startTableWidth + delta)
      state.table.style.minWidth = ''
      state.table.style.maxWidth = 'none'
      state.table.style.setProperty('width', newTableWidth + 'px', 'important')
    }
  }

  const onMouseUp = () => {
    if (!state.active) return
    state.active = false
    doc.removeEventListener('mousemove', onMouseMove)
    doc.removeEventListener('mouseup', onMouseUp)
    if (doc.body) doc.body.style.cursor = ''
    try {
      const html = sunEditor.getContents(true)
      if (html != null && typeof onResizeEnd === 'function') onResizeEnd(html)
    } catch (_) {}
  }

  const onMouseDown = (e) => {
    const cell = e.target.closest('td, th')
    if (!cell) return
    const table = cell.closest('table')
    if (!table) return
    const rect = cell.getBoundingClientRect()
    if (e.clientX < rect.right - RESIZE_GUTTER) return
    e.preventDefault()
    const firstRow = table.querySelector('tr')
    const isLastCol = firstRow && cell.cellIndex === firstRow.cells.length - 1
    const tableRect = table.getBoundingClientRect()
    state = {
      active: true,
      table,
      colIndex: cell.cellIndex,
      startX: e.clientX,
      startWidth: rect.width,
      startTableWidth: tableRect.width,
      isLastCol: !!isLastCol
    }
    if (doc.body) doc.body.style.cursor = 'col-resize'
    doc.addEventListener('mousemove', onMouseMove)
    doc.addEventListener('mouseup', onMouseUp)
  }

  let lastResizeHintCell = null
  const onMouseMoveHint = (e) => {
    if (state.active) return
    const cell = e.target.closest('td, th')
    const rect = cell ? cell.getBoundingClientRect() : null
    const inGutter = cell && e.clientX >= rect.right - RESIZE_GUTTER
    if (inGutter) {
      if (lastResizeHintCell !== cell) {
        if (lastResizeHintCell) lastResizeHintCell.style.cursor = ''
        lastResizeHintCell = cell
        cell.style.cursor = 'col-resize'
      }
    } else {
      if (lastResizeHintCell) {
        lastResizeHintCell.style.cursor = ''
        lastResizeHintCell = null
      }
    }
  }

  container.addEventListener('mousedown', onMouseDown, true)
  container.addEventListener('mousemove', onMouseMoveHint, true)
}
